var _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgShopsPageShop1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 249,
    height: 110,
    viewBox: "0 0 249 110",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_71_666)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 10.0557,
    y: 10,
    width: 226.635,
    height: 88,
    rx: 10,
    fill: "#E30613"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M125.683 62.8008V42.1995H138.839V46.9844H131.169V62.8008H125.683Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M155.393 62.8008V54.7323H147.243V62.8008H141.757V42.1995H147.243V49.8877H155.393V42.1995H160.879V62.8008H155.393Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M192.714 62.8008V46.9844H186.307V42.1995H204.642V46.9844H198.203V62.8008H192.714Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M178.235 62.798V51.0598L169.502 62.798H164.915V42.2023H170.401V53.8183L178.987 42.2023H183.724V62.798H178.235Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M94.1565 62.8008V50.5575L88.6791 57.0255L83.2018 50.5575V62.8008H77.7158V42.1995H83.13L88.6791 49.2832L94.2283 42.1995H99.6424V62.8008H94.1565Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M110.057 55.5552H115.156L112.606 49.0958L110.057 55.5552ZM118.015 62.7979L116.867 59.9115H108.338L107.189 62.7979H101.675L110.112 42.1993H115.184L123.624 62.7979H118.015Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M35.2373 46.3854C35.2426 43.8974 36.2449 41.5128 38.0248 39.7537C39.8046 37.9947 42.217 37.0045 44.7337 37H66.6575V41.7708H44.7394C43.5028 41.776 42.3183 42.2637 41.4436 43.128C40.5689 43.9922 40.0748 45.1629 40.0687 46.3854L40.04 54.3944C39.94 55.4205 39.499 56.3849 38.7859 57.1373C38.0728 57.8894 37.1278 58.3869 36.0985 58.5522L35.2373 58.6827V46.3854Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M35.2383 68V63.2291H57.162C58.3989 63.2232 59.5834 62.7347 60.4581 61.8702C61.3326 61.0054 61.8267 59.8344 61.8327 58.6117V51.0114C61.8387 49.9087 62.2411 48.8441 62.9678 48.0076C63.6946 47.1711 64.6984 46.6173 65.8 46.445L66.6612 46.3173V58.6117C66.6559 61.1001 65.6537 63.4849 63.8739 65.2444C62.0942 67.0039 59.6818 67.9946 57.1649 68H35.2383Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M53.8107 58.6998V52.5327L50.9515 55.9072L48.0951 52.5327V58.6998H44.3086V46.5643H47.8941L50.9515 50.4666L54.0088 46.5643H57.5944V58.6998H53.8107Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_71_666",
    x: 0.0556641,
    y: 0,
    width: 248.636,
    height: 110,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_71_666"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_71_666"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_71_666",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShopsPageShop1);
export default __webpack_public_path__ + "static/media/shopsPage_shop1.06a9d721fe1cbc6012c4129440c04301.svg";
export { ForwardRef as ReactComponent };